// Auswahl der Events für den Startseiten-Shortcode (#24). Welche Kategorien
// gezeigt werden, steht als Attribut am Shortcode — die Funktion ist auf keine
// festgelegt. Voreinstellung 'upcoming', damit entspricht sie der Live-Startseite.
//
// Sortierung: aufsteigend nach erstem Messetag, Events ohne Datum zuerst.
// Das ist genau die Reihenfolge der Live-Startseite (dort sortiert der leere
// Datumswert vor jedem Datum).
export const ALLE_KATEGORIEN = 'alle'

const ersterTag = (event) => (event.days && event.days[0] && event.days[0].date) || ''

const selectEvents = (events, { status = ['upcoming'], limit = null } = {}) => {
    if (!events || !events.length) return []

    const zeigeAlles = status.includes(ALLE_KATEGORIEN)
    const auswahl = events
        .filter(event => zeigeAlles || status.includes(event.status))
        .slice()
        .sort((a, b) => ersterTag(a).localeCompare(ersterTag(b)))

    return limit > 0 ? auswahl.slice(0, limit) : auswahl
}

export default selectEvents
